import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen, Card, Line, Panel, Column} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {DataGrid,IDataGridLayout,EmptyState} from 'ktm-ui';
import BencatRecordScreen from 'planadmin/bencat/Record';
import BencatNewScreen from 'planadmin/bencat/New';

interface IdsBenefitCategories {
    Id:string;
    Name:string;
    Description:string;
    Policy_Id:string;
    FlexSingleLimit:number;
    FlexCoupleLimit:number;
    FlexFamilyLimit:number;
};

interface IdsBenefits {
    Id:string;
    HasFlex:boolean;
};
export default KTMScreen({name:"planadmin.policy.benefit-categories"}, class extends React.Component<{policy_id:string}> {

    data:{
        dsBenefitCategories:IdsBenefitCategories[];
        dsBenefits:IdsBenefits;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsBenefitCategories";
        await KTMApi.start(screen,{
            "@policy_id":this.props.policy_id,
        });
        screen.title = "Benefit categories";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Panel>
                <Column>
                    {draw(this.default_view)}
                    {draw(this.request_edits)}
                </Column>
            </Panel>
        );
    }

    default_view({field,draw,action,collection}:RenderEvent){
        let layout:IDataGridLayout = {
            columns:[
                {name:"Name",label:"Name",type:"character", width:300},
            ],
            sort:[{name:"Name"}]
        };

        if (this.data.dsBenefits.HasFlex) {
            layout.columns.push(
                { name: "FlexSingleLimit", label: "Flex Single Limit", type: "decimal" },
                { name: "FlexCoupleLimit", label: "Flex Couple Limit", type: "decimal" },
                { name: "FlexFamilyLimit", label: "Flex Family Limit", type: "decimal" }
            );
        }

        return (
            <DataGrid 
                collection={collection("@dsBenefitCategories")} 
                layout={layout} 
                onRowClick={action(this.show_record)}
            />
        );
    }

    request_edits({field,draw,action}:RenderEvent){
        return (
        <div style={{marginTop: "100px"}}>
            <Card label="Request Edits">
                <Line>
                    <div>
                    Click on the names in the chart above for more information on each benefit category, and to view/edit the limits. To add or remove a benefit category from your plan, email <a href="#" style={{color: "#4987ef"}}>support@nationalhealthclaim.com</a> with your request.
                    </div>
                </Line>
            </Card>
        </div>
        );
    }


    empty_state({field,draw,action}:RenderEvent){
        return (
            <EmptyState label="No benefit categories created yet." icon="folder">
                {/* <Button action={action(this.new_record)} label="Add benefit category" style="primary"/> */}
            </EmptyState>
        );
    }

    async show_record({screen}:ActionEvent){
        screen.browse(<BencatRecordScreen bencat_id={screen.getValue("Id")}/>,{label:"Benefit category"});
    }

    async refresh_row({screen,eventValue}:ActionEvent){
        await KTMApi.refreshRow(screen,{collection:
"@dsBenefitCategories",rowid:eventValue});
    }

    async new_record({screen}:ActionEvent){
        await screen.openDialog(<BencatNewScreen policy_id={this.props.policy_id}/>
,{onRecordChanged:this.after_new});
    }

    async after_new({screen,eventValue}:ActionEvent){
        screen.showLayout(this.main);
        await KTMApi.refreshRow(screen,{collection:
"@dsBenefitCategories",rowid:eventValue});
        screen.locate("@dsBenefitCategories",eventValue);
        await screen.triggerAction(this.show_record);
    }

});
